import React, { FunctionComponent, useMemo } from 'react';

import useTheme from '@gojob/ui-bits/styles/useTheme';
import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image';

export interface AvatarProps extends GatsbyImageProps {
  size?: number;
  hotspot?: {
    x?: number;
    y?: number;
  };
}

const useStyles = (size = 12) => {
  const { spacing } = useTheme();
  return useMemo(() => {
    return {
      root: {
        height: spacing(size),
        width: spacing(size),
        minHeight: spacing(size),
        minWidth: spacing(size),
        borderRadius: '50%',
      },
    };
  }, [spacing, size]);
};

const Avatar: FunctionComponent<AvatarProps> = (props) => {
  const { size, hotspot, imgStyle, ...other } = props;
  const classes = useStyles(size);

  const style = useMemo(() => {
    const { x, y } = hotspot || {};
    if (typeof x === 'number' && typeof y === 'number') {
      return { objectPosition: `${x * 100}% ${y * 100}%`, ...imgStyle };
    }
    return imgStyle;
  }, [hotspot, imgStyle]);

  return <GatsbyImage css={classes.root} imgStyle={style} {...other} />;
};

export default Avatar;
